// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__162Nz","info":"UpdateTermsInfo_info__1lgUh"};